import { useCurrentUser } from '../../contexts/CurrentUser';
import { CopilotProvider as ClassicProvider, useCopilotPage as useClassicPage } from '../CopilotButtonAssistantUI/CopilotContext';
import { CopilotButtonAssistantUI as ClassicButton } from '../CopilotButtonAssistantUI/CopilotButtonAssistantUI';
import { CopilotMinProvider, useCopilotMinPage } from '../CopilotMin/CopilotMinContext';
import { CopilotMinButton } from '../CopilotMin/CopilotMinButton';

// Two independent Copilots live side by side. The classic one is the unchanged
// component for the previous backend; the `copilot_min` workspace feature flag
// switches the whole workspace to the new one. They share no state, storage
// key or styles, so the classic code path is not touched by the new one.
export function useCopilotMinEnabled() {
  const [currentUser] = useCurrentUser();
  return !!currentUser?.workspace?.config?.featureflags?.includes('copilot_min');
}

export function CopilotProvider({ children }) {
  const Provider = useCopilotMinEnabled() ? CopilotMinProvider : ClassicProvider;
  return <Provider>{children}</Provider>;
}

export function CopilotButton() {
  return useCopilotMinEnabled() ? <CopilotMinButton /> : <ClassicButton />;
}

// Both hooks run, but only the mounted provider has a context: the other one is a no-op.
export function useCopilotPage(page) {
  useClassicPage(page);
  useCopilotMinPage(page);
}
